import { ProductColor } from '@aloft/toolkit-sui';

import { CompSelectionProperty } from '../../types.ts';

export function getPinColor(property: CompSelectionProperty): ProductColor {
  switch (property.mlsStatus?.toLowerCase()) {
    case 'active':
      return 'pinActive';
    case 'sold':
    case 'recently_sold':
      return 'pinSold';
    case 'pending':
      return 'pinPending';
    default:
      return 'pinOther';
  }
}
